import React, { Component } from 'react';
import { DownOutlined, DoubleRightOutlined } from '@ant-design/icons';
import './index.scss';

export default class componentName extends Component {
  constructor(props) {
    super(props);
    this.scrollWrap = React.createRef();
    this.scrollList = React.createRef();
    this.trackVertical = React.createRef();
    this.thumbVertical = React.createRef();
    this.state = {
      options: {
        clientWidth: 0, //容器宽度
        clientHeight: 0, //容器高度
        scrollWidth: 0, //滚动条宽度
        scrollHeight: 0, //滚动条高度
        bottom: 0, //底部距离
        right: 0, //右侧距离
        animated: 0, //动画时长
        newCount: 0, //新消息数量
      },
    };
  }
  componentDidMount() {
    this.scrollWrap.current.addEventListener('mousewheel', this.mousewheel);
    this.scrollWrap.current.addEventListener('DOMMouseScroll', this.mousewheel);
    this.trackVertical.current.addEventListener('click', this.scrollJump);
    this.thumbVertical.current.addEventListener('click', this.stopEvent);
    this.thumbVertical.current.addEventListener(
      'mousedown',
      this.handleVerticalThumbMouseDown
    );
    document.body.addEventListener(
      'mousemove',
      this.handleVerticalThumbMouseMove
    );
    document.body.addEventListener('mouseup', this.handleVerticalThumbMouseUp);
  }
  getOptions = () => {
    return this.state.options;
  };
  componentWillUnmount() {
    this.scrollWrap.current.removeEventListener('mousewheel', this.mousewheel);
    this.scrollWrap.current.removeEventListener(
      'DOMMouseScroll',
      this.mousewheel
    );
    this.trackVertical.current.removeEventListener('click', this.scrollJump);
    this.thumbVertical.current.addEventListener('click', this.stopEvent);
    this.thumbVertical.current.removeEventListener(
      'mousedown',
      this.handleVerticalThumbMouseDown
    );
    document.body.removeEventListener(
      'mousemove',
      this.handleVerticalThumbMouseMove
    );
    document.body.removeEventListener(
      'mouseup',
      this.handleVerticalThumbMouseUp
    );
  }
  //鼠标滚轮
  mousewheel = (event) => {
    this.stopEvent(event);
    if (event.wheelDelta) {
      this.scrollY(event.wheelDelta > 0 ? 100 : -100, 0);
    } else if (event.detail) {
      this.scrollY(event.detail > 0 ? -100 : 100, 0);
    }
  };
  //滚动
  scrollY = (y, animated = 250) => {
    const { options } = this.state;
    let bytop = false;
    let nBottom = options.bottom + y;
    if (nBottom < 0) nBottom = 0;
    if (nBottom + options.clientHeight > options.scrollHeight) {
      nBottom = options.scrollHeight - options.clientHeight;
      bytop = true;
      this.clientY = 0;
    }
    if (nBottom == options.bottom) return;
    options.bottom = nBottom;
    options.animated = animated;
    if (options.bottom == 0) {
      options.newCount = 0;
    }
    this.setState({ options }, () => {
      const { onScrollToTop } = this.props;
      if (bytop && onScrollToTop) onScrollToTop(options);
      else if (options.bottom == 0) {
        const { onScrollToBottom } = this.props;
        onScrollToBottom && onScrollToBottom();
      }
    });
  };
  //变更
  update = (n) => {
    const { options } = this.state;
    options.clientHeight = this.scrollWrap.current?.clientHeight || 0;
    options.scrollHeight = this.scrollList.current?.clientHeight || 0;
    if (options.scrollHeight <= options.clientHeight) {
      options.bottom = 0;
      options.newCount = 0;
    }
    this.setState({ options });
  };
  //滚动至底部
  scrollToBottom = (animated = 500) => {
    const { options } = this.state;
    options.clientHeight = this.scrollWrap.current.clientHeight;
    options.scrollHeight = this.scrollList.current.clientHeight;
    options.bottom = 0;
    options.newCount = 0;
    options.animated = animated;
    this.setState({ options }, () => {
      //延迟 更新一次
      setTimeout(this.update.bind(this), 1000);
    });
  };
  //追加新项
  addCount = (n = 1) => {
    const { options } = this.state;
    if (options.bottom == 0) {
      this.scrollToBottom();
      return;
    }
    let scrollHeight = this.scrollList.current.clientHeight;
    options.newCount += n;
    options.bottom += scrollHeight - options.scrollHeight;
    options.clientHeight = this.scrollWrap.current.clientHeight;
    options.scrollHeight = this.scrollList.current.clientHeight;
    this.setState({ options }, () => {
      //延迟 更新一次
      setTimeout(this.update.bind(this), 1000);
    });
  };
  //跳跃
  scrollJump = (event) => {
    let offsetTop = Math.abs(
      event.pageY - this.getPageY(this.scrollWrap.current.offsetParent)
    );
    const { options } = this.state;
    let bottom = (1 - offsetTop / options.clientHeight).toFixed(2);
    let scrollBarH = (
      (options.clientHeight / options.scrollHeight / 2) *
      options.scrollHeight
    ).toFixed(2);
    this.scrollTo(parseInt(bottom * options.scrollHeight - scrollBarH));
    event.stopPropagation && event.stopPropagation();
  };
  //滚动指定位置
  scrollTo = (to, animated = 500) => {
    const { options } = this.state;
    let bytop = false;
    if (to + options.clientHeight > options.scrollHeight) {
      to = options.scrollHeight - options.clientHeight;
      bytop = true;
      this.clientY = 0;
    }
    if (to < 0) to = 0;
    if (to == options.bottom) return;
    options.bottom = to;
    options.animated = animated;
    if (options.bottom == 0) {
      options.newCount = 0;
    }
    this.setState({ options }, () => {
      const { onScrollToTop } = this.props;
      if (bytop && onScrollToTop) onScrollToTop(options);
      else if (options.bottom == 0) {
        const { onScrollToBottom } = this.props;
        onScrollToBottom && onScrollToBottom();
      }
    });
  };
  //位置计算
  getPageY = (dom, top = 0) => {
    if (dom.offsetTop) top += dom.offsetTop;
    if (dom.offsetParent) return this.getPageY(dom.offsetParent, top);
    return top;
  };
  //销毁
  destroy = () => {
    const { options } = this.state;
    options.clientHeight = 0;
    options.scrollHeight = 0;
    options.bottom = 0;
    options.animated = 0;
    options.newCount = 0;
    this.setState({ options });
  };
  stopEvent = (event) => {
    event.stopPropagation && event.stopPropagation();
    event.preventDefault && event.preventDefault();
  };
  handleVerticalThumbMouseDown = (event) => {
    if (this.clientY) return;
    this.stopEvent(event);
    this.clientY = event.clientY;
  };
  handleVerticalThumbMouseMove = (event) => {
    if (!this.clientY) return;
    this.stopEvent(event);
    let n = this.clientY - event.clientY;
    const { options } = this.state;
    let h = (n / options.clientHeight) * options.scrollHeight;
    this.clientY = event.clientY;
    this.scrollY(h, 0);
  };
  handleVerticalThumbMouseUp = (event) => {
    if (!this.clientY) return;
    this.stopEvent(event);
    this.clientY = 0;
  };
  //滚动至底部
  toBottom = () => {
    this.scrollToBottom();
    const { onScrollToBottom } = this.props;
    onScrollToBottom && onScrollToBottom();
  };
  render() {
    const { options } = this.state;
    const { type = 'chat' } = this.props;
    const scrollBarH = (options.clientHeight / options.scrollHeight).toFixed(2);
    const scrollBarB = (options.bottom / options.scrollHeight).toFixed(2);
    return (
      <div className="msg-scroll-view">
        <div className="msg-scroll-wrap" ref={this.scrollWrap}>
          <div
            className="msg-scroll-list"
            ref={this.scrollList}
            style={{
              bottom: options.bottom * -1 + 'px',
              transition: `all ${options.animated}ms`,
            }}
          >
            {this.props.children}
          </div>
        </div>
        <div
          className="msg-scroll-trackY"
          ref={this.trackVertical}
          style={{
            opacity: scrollBarH < 1 ? 1 : 0,
          }}
        >
          <div
            className="msg-scroll-thumbY"
            ref={this.thumbVertical}
            style={{
              height: scrollBarH * 100 + '%',
              bottom: scrollBarB * 100 + '%',
            }}
          ></div>
        </div>
        {type == 'room' ? (
          <div>
            {scrollBarH > 0 && options.bottom > 0 && options.newCount ? (
              <div
                onClick={this.toBottom}
                className="an-scroll-to-bottom-byRoom animated fadeInUp"
              >
                <DownOutlined />
                <span>有更多新消息</span>
              </div>
            ) : null}
          </div>
        ) : (
          <div>
            {scrollBarH > 0 && options.bottom > 0 ? (
              <div
                onClick={this.toBottom}
                className="an-scroll-to-bottom animated fadeInRight"
              >
                <DoubleRightOutlined />
                {options.newCount ? (
                  <span>
                    回到底部<b>{`（${options.newCount}）`}</b>
                  </span>
                ) : (
                  <span>回到底部</span>
                )}
              </div>
            ) : null}
          </div>
        )}
      </div>
    );
  }
}
